import React, { PropTypes } from 'react';

import { button, bar as barOpaque, label, barTransparent } from './styles.module.css';

/**
 * Header menu button presentational component.
 */
const HeaderMenuButton = ({ className, navId, navVisible, onClick, transparent }) => {
  const barStyle = transparent ? barTransparent : barOpaque;
  return (
    <button
      className={[button, className].join(' ')}
      onClick={onClick}
      aria-controls={navId}
      aria-expanded={navVisible}
    >
      <span className={label}>Toggle navigation</span>
      <span className={barStyle} />
      <span className={barStyle} />
      <span className={barStyle} />
    </button>
  );
};

HeaderMenuButton.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * String ID for the target nav component.
   */
  navId: PropTypes.string,
  /**
   * Boolean whether target nav is expanded.
   */
  navVisible: PropTypes.bool,
  /**
   * Function called on button click.
   */
  onClick: PropTypes.func,
  /**
   * Boolean whether to use transparent styles.
   */
  transparent: PropTypes.bool,
};

HeaderMenuButton.defaultProps = {
  className: '',
  navId: undefined,
  navVisible: undefined,
  onClick: () => {},
  transparent: false,
};

export default HeaderMenuButton;



// WEBPACK FOOTER //
// ./app/src/components/HeaderMenu/components/HeaderMenuButton/index.jsx